import React, {Component} from 'react';
import {Input, Button, Card, Row, Col, Form, DatePicker, Icon, Select} from 'antd';
import * as moment from 'moment';

const {Item: FormItem} = Form;
const {Option} = Select;

class NewNonEngineer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false
        }
    }
    render() {
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 18,
                    offset: 6,
                },
            },
        };

        const {belongsTo, form, storeNonEngineer, history, match, branches} = this.props;
        const { getFieldDecorator } = form;
        const getDefaultVal = (key) => {
            return '';
        };
        const getDefaultDateValue = (key) => {
            return moment();
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            return form.validateFieldsAndScroll((err, values) => {
                if (err) {
                    return;
                }
                const dateFields = [
                    'crb_expiry_date',
                    'working_at_heights',
                    'manual_handling',
                    'asbestos_cat_b',
                    'ppe'
                ];
                dateFields.forEach(field => {
                    if (values[field]) {
                        values = {...values, [field]: values[field].format('DD/MM/YYYY')}
                    }
                });
                this.setState({submitting: true});
                return storeNonEngineer(belongsTo, values).then(res => {
                    this.setState({submitting: false});
                    if (res.error) {
                        const errors = res.error.res.errors;
                        const fields = {};
                        Object.keys(errors).forEach(field => {
                            const errs = errors[field];
                            fields[field] = {
                                value: values[field],
                                errors: errs.map(err => new Error(err))
                            }
                        });
                        return form.setFields(fields);
                    }
                    return history.push(match.url.replace('new', res.res.data.id))
                });
            });
        };

        const onCancel = (e) => {
            return this.props.history.goBack();
        };

        return (
            <Card loading={this.props.isFetching} bordered={false}>
                <Row gutter={16}>
                    <Col>
                        <Form onSubmit={handleSubmit}>
                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label={(
                                    <span>Name</span>
                                )}
                            >
                                {getFieldDecorator('full_name', {
                                    initialValue: getDefaultVal('full_name'),
                                    rules: [{ required: true, message: 'Please input your name!', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Job Title"
                            >
                                {getFieldDecorator('job_title', {
                                    initialValue: getDefaultVal('job_title'),
                                    rules: [{ required: true, message: 'Please input your job title!', whitespace: true }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            {branches ? (
                                <FormItem
                                    hasFeedback
                                    {...formItemLayout}
                                    label="Branch Location"
                                >
                                    {getFieldDecorator('branch_location', {
                                        initialValue: 'Select a branch location',
                                        rules: [{ required: true, message: 'Please select branch location'}],
                                    })(
                                        <Select>
                                            {branches.data.map(b => (
                                                <Option value={b.id+''} key={b.id}>{b.branch_name} - {b.address_line_1} {b.main_office ? '(M)' : ''}</Option>
                                            ))}
                                        </Select>
                                    )}
                                </FormItem>
                            ) : null}

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="E-mail"
                            >
                                {getFieldDecorator('email', {
                                    initialValue: getDefaultVal('email'),
                                    rules: [{
                                        type: 'email', message: 'The input is not valid E-mail!',
                                    }, {
                                        required: true, message: 'Please input your E-mail!', whitespace: true,
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Phone Number"
                            >
                                {getFieldDecorator('phone_number', {
                                    initialValue: getDefaultVal('phone_number'),
                                    rules: [
                                        { pattern: /\d{11}$/, message: 'Invalid phone number' },
                                        { required: true, message: 'Please input your phone number!', whitespace: true }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="CRB"
                            >
                                {getFieldDecorator('crb_expiry_date', {
                                    initialValue: getDefaultDateValue('crb_expiry_date'),
                                    rules: [
                                        { type: 'object', required: true, message: 'Please input CRB expiry date!', whitespace: true }],
                                })(
                                    <DatePicker format='DD/MM/YYYY'/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Working At Heights"
                            >
                                {getFieldDecorator('working_at_heights', {
                                    initialValue: getDefaultDateValue('working_at_heights'),
                                    rules: [
                                        { type: 'object', required: true, message: 'Please input working at heights expiry date!', whitespace: true }],
                                })(
                                    <DatePicker format='DD/MM/YYYY'/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Manual Handling"
                            >
                                {getFieldDecorator('manual_handling', {
                                    initialValue: getDefaultDateValue('manual_handling'),
                                    rules: [
                                        { type: 'object', required: true, message: 'Please input manual handling expiry date!', whitespace: true }],
                                })(
                                    <DatePicker format='DD/MM/YYYY'/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="Asbestos Cat B"
                            >
                                {getFieldDecorator('asbestos_cat_b', {
                                    initialValue: getDefaultDateValue('asbestos_cat_b'),
                                    rules: [
                                        { type: 'object', required: true, message: 'Please input asbestos cat B expiry date!', whitespace: true }],
                                })(
                                    <DatePicker format='DD/MM/YYYY'/>
                                )}
                            </FormItem>

                            <FormItem
                                hasFeedback
                                {...formItemLayout}
                                label="PPE"
                            >
                                {getFieldDecorator('ppe', {
                                    initialValue: getDefaultDateValue('ppe'),
                                    rules: [
                                        { type: 'object', required: true, message: 'Please input PPE expiry date!', whitespace: true }],
                                })(
                                    <DatePicker format='DD/MM/YYYY'/>
                                )}
                            </FormItem>

                            <FormItem {...tailFormItemLayout}>
                                <Button onClick={onCancel} style={{marginRight: 10}}>Cancel</Button>
                                {this.state.submitting ? (
                                    <Button><Icon type="loading" spin/> Processing</Button>
                                ) : (
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                )}
                            </FormItem>
                        </Form>
                    </Col>
                </Row>
            </Card>
        );
    }
}

export default Form.create()(NewNonEngineer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/shared/NewNonEngineer.js